/**
 * The attribute an early inline script sets on `<html>` when the reader has not
 * asked for reduced motion. CSS hides an animated element's "before" state only
 * under it, so the server-rendered page is always the finished page: a reader
 * whose script never runs, or who prefers reduced motion, sees every section in
 * its final state, and a reader whose script runs never sees the finished state
 * flash before its entrance plays.
 */
export const MOTION_ATTRIBUTE = "data-motion";

/** Motion is on when the early script set the page's motion attribute. Browser
    only: call it from an effect, a handler or an observer callback. */
export function hasMotion(): boolean {
  return document.documentElement.hasAttribute(MOTION_ATTRIBUTE);
}

const SCRIPT = `(function(){try{if(window.matchMedia("(prefers-reduced-motion: no-preference)").matches)document.documentElement.setAttribute("${MOTION_ATTRIBUTE}","")}catch(e){}})()`;

/**
 * Rendered in the root layout's `<head>`, beside Mantine's color-scheme
 * script, so the browser runs it while parsing, before first paint. An inline
 * script only runs when it arrives in server HTML; one rendered by a client
 * component during a client-side navigation never executes. From the root it
 * runs on every full page load, whichever route the visitor lands on, and the
 * attribute then holds across client-side navigations. `<html>` already
 * carries `suppressHydrationWarning` for the attribute this adds.
 */
export default function MotionScript() {
  return <script dangerouslySetInnerHTML={{ __html: SCRIPT }} />;
}
